export default __webpack_public_path__ + "static/media/kwiecien.933f2691.mp3";